<template>
  <v-dialog v-model="globalStore.kioskQrDialog" max-width="420px" scrollable>
    <v-card>
      <v-card-title color="primary" class="bg-primary text-background text-h6">
        {{ resources.KioskQrTitle || "Código del kiosco" }}
      </v-card-title>

      <v-card-text class="text-center pt-4">
        <div class="mb-2 text-subtitle-1">{{ globalStore.kioskQr.branchName }}</div>
        <p class="text-body-2 mb-4">
          {{
            resources.KioskQrInstructions ||
            "Escanee este código con la cámara del dispositivo del kiosco para abrirlo con sus credenciales."
          }}
        </p>
        <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR" width="280" height="280" />
        <v-text-field
          class="mt-4"
          :model-value="globalStore.kioskQr.url"
          readonly
          density="compact"
          variant="outlined"
          :label="resources.KioskUrl || 'URL del kiosco'"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="outlined" class="mr-2 mb-2" @click="globalStore.closeKioskQrDialog">
          {{ resources.Close || "Cerrar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import QRCode from "qrcode";

const globalStore = window.useGlobalStore();
const { resources } = storeToRefs(globalStore);

const qrDataUrl = ref("");

watch(
  () => globalStore.kioskQr.url,
  async (url) => {
    if (!url) {
      qrDataUrl.value = "";
      return;
    }
    try {
      qrDataUrl.value = await QRCode.toDataURL(url, { width: 280, margin: 1 });
    } catch (ex) {
      console.error(ex);
      qrDataUrl.value = "";
    }
  }
);
</script>
